import styled from "@emotion/styled";
import { LineItemGridWrapper } from "components/OrderDetailsLineItem/OrderDetailsLineItem.styles.ts";
import { AlertTitle } from "@mui/material";

export const OrderDetailsHeaderWrapper = styled.div(({ theme }) => ({
	backgroundColor: theme.palette.background.default,
	display: "flex",
	flexDirection: "column",
	gap: "16px",
	padding: 20
}));

export const NoOrderDetailsBannerContainer = styled.div(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	width: "100%",
	"> div": {
		margin: 0,
		width: "100%",
		color: theme.project.colors.fontColors.main
	}
}));

export const OrderDetailsTitle = styled.h6(({ theme }) => ({
	color: theme.project.colors.fontColors.main,
	margin: "0 0 0 16px",
	paddingTop: 16
}));

export const PageContent = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: 16,
	padding: "0 16px"
});

export const UngroupedGridWrapper = styled.div({
	[`${LineItemGridWrapper}`]: {
		padding: 16
	}
});

export const ChargesContainer = styled.div({
	display: "flex",
	flexDirection: "column",
	padding: "0px 16px",
	width: "100%"
});

export const OrderCharge = styled(AlertTitle, {
	shouldForwardProp: (prop) => prop !== "isSubtotal"
})<{ isSubtotal: boolean }>(({ theme, isSubtotal }) => ({
	color: isSubtotal ? theme.project.colors.primaryColors.main : theme.project.colors.fontColors.main,
	display: "flex",
	width: "100%",
	gap: 8,
	margin: 0,
	justifyContent: "flex-end",
	textAlign: "right",
	span: {
		textAlign: "right",
		"&:first-of-type": {
			...theme.project.typography.alert.alertTitle,
			marginRight: "20px"
		},
		"&:last-of-type": {
			...theme.project.typography.body.body1,
			width: "120px"
		}
	},
	[theme.breakpoints.down("md")]: {
		justifyContent: "space-between"
	}
}));

export const WarningContainer = styled.div(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.semanticColors.warning,
	a: {
		color: theme.project.colors.semanticColors.warning,
		textDecorationColor: `${theme.project.colors.semanticColors.warning}90`,
		"&:hover": {
			textDecorationColor: theme.project.colors.semanticColors["warning:hover"]
		}
	}
}));

export const AcknowledgementTotalPrice = styled.div<{ isListPrice: boolean }>(({ isListPrice }) => ({
	display: "flex",
	flexDirection: isListPrice ? "column-reverse" : "column",
	width: "100%",
	alignItems: "flex-end",
	"> div": {
		boxSizing: "border-box",
		width: "100%",
		marginBottom: "16px"
	}
}));
